module.exports = __webpack_public_path__ + "img/insta.63696989.png";